const ALLOWED_TAGS = new Set(['DIV', 'P', 'BR', 'SPAN', 'B', 'STRONG', 'I', 'EM', 'U', 'FONT']);
const DROP_CONTENT_TAGS = new Set(['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED', 'SVG', 'MATH']);
const ALLOWED_ATTRS = new Set(['style']);
const ALLOWED_STYLES = new Set([
  'color',
  'background-color',
  'font-size',
  'font-weight',
  'text-decoration',
  'font-style',
]);
const TRANSLATOR_MARKER_RE = /_mst[a-z0-9_-]*|_istranslated/i;

function sanitizeStyle(styleText = '') {
  return styleText
    .split(';')
    .map((part) => part.trim())
    .filter(Boolean)
    .map((part) => {
      const idx = part.indexOf(':');
      if (idx === -1) return null;
      const name = part.slice(0, idx).trim().toLowerCase();
      const value = part.slice(idx + 1).trim();
      if (!ALLOWED_STYLES.has(name) || !value) return null;
      return `${name}: ${value}`;
    })
    .filter(Boolean)
    .join('; ');
}

function sanitizeNode(node, doc) {
  if (node.nodeType === Node.TEXT_NODE) {
    return doc.createTextNode(node.textContent || '');
  }
  if (node.nodeType !== Node.ELEMENT_NODE) {
    return null;
  }

  const tag = node.tagName.toUpperCase();
  const childNodes = Array.from(node.childNodes)
    .map((child) => sanitizeNode(child, doc))
    .filter(Boolean);

  if (!ALLOWED_TAGS.has(tag)) {
    if (DROP_CONTENT_TAGS.has(tag)) return null;
    if (childNodes.length === 0) return null;
    const frag = doc.createDocumentFragment();
    childNodes.forEach((child) => frag.appendChild(child));
    return frag;
  }

  const clean = doc.createElement(tag.toLowerCase());
  for (const attr of Array.from(node.attributes)) {
    const name = attr.name.toLowerCase();
    if (name.startsWith('on')) continue;
    if (name.startsWith('_mst') || name === '_istranslated') continue;
    if (name.startsWith('data-')) continue;
    if (!ALLOWED_ATTRS.has(name)) continue;
    if (name === 'style') {
      const safeStyle = sanitizeStyle(attr.value);
      if (safeStyle) clean.setAttribute('style', safeStyle);
      continue;
    }
    clean.setAttribute(name, attr.value);
  }

  childNodes.forEach((child) => clean.appendChild(child));
  return clean;
}

export function detectTranslatorArtifacts(html = '') {
  return TRANSLATOR_MARKER_RE.test(html);
}

export function sanitizeDiaryHtml(html = '') {
  const parser = new DOMParser();
  const parsed = parser.parseFromString(`<div>${html || ''}</div>`, 'text/html');
  const wrapper = parsed.body.firstElementChild;
  if (!wrapper) return '';

  const out = document.implementation.createHTMLDocument('');
  const cleanWrapper = out.createElement('div');
  Array.from(wrapper.childNodes)
    .map((child) => sanitizeNode(child, out))
    .filter(Boolean)
    .forEach((child) => cleanWrapper.appendChild(child));

  return cleanWrapper.innerHTML.trim();
}
